export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:chunkError', ({ error }) => {
    useLogger().error('Caught chunk load error', { error })
    useNuxtApp().$sentry.captureException(error)
  })
})
